import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, concatMap, from, map, switchMap, toArray } from 'rxjs';

import { EvaluationContent, EvaluationWithUrl } from '../models/evaluation.model';
import { FileQueryParams, Result, ResultQueryParams } from '../models/result.model';
import { ListResponse } from '../models/utility.model';
import { ResultGateway } from '../usecases/result.gateway';

@Injectable()
export class ResultService extends ResultGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listResults(params: ResultQueryParams): Observable<ListResponse<Result>> {
    const { projectId, unitId } = params;
    return this._http.get<ListResponse<Result>>(`api/vgs/projects/${projectId}/units/${unitId}/results`, { params });
  }

  getEvaluation(projectId: string, unitId: string, resultId: string): Observable<EvaluationContent[]> {
    return this._http
      .get<{ items: EvaluationWithUrl[] }>(`api/vgs/projects/${projectId}/units/${unitId}/results/${resultId}/batch-get-evaluations`)
      .pipe(
        switchMap(({ items }) => {
          return from(items).pipe(
            concatMap(item =>
              this._http.get<Omit<EvaluationContent, 'fileId' | 'evaluationStatus'>>(item.url).pipe(
                map(content => ({
                  fileId: item.fileId,
                  evaluationStatus: item.evaluationStatus,
                  ...content,
                })),
              ),
            ),
            toArray(),
          );
        }),
      );
  }

  getFile(params: FileQueryParams): Observable<{ url: string }> {
    const { projectId, unitId, resultId, fileId } = params;
    return this._http.get<{ url: string }>(`api/vgs/projects/${projectId}/units/${unitId}/results/${resultId}/files/${fileId}`);
  }
}
